window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var cfg = ns.config;
  var st = ns.state;

  function stateFromQuery() {
    var state = st.get();
    var query = document.location.search;
    var values = {};
    var pairs = null;

    if (query != "") {
      query = query.substring(1);
      pairs = query.split("&");
      for (var x = 0; x < pairs.length; x++) {
        var d = pairs[x].split("=");
        if (d[0] === "time") {
          d[1] = moment(d[1], "HHmm").format("HH:mm");
        }
        values[d[0]] = decodeURIComponent(d[1]);
        if ($.inArray(d[0], ["event", "venue", "players", "order"]) > -1) {
          values[d[0]] = parseInt(values[d[0]]);
        }
        if (d[0] === "events") {
          values[d[0]] = values[d[0]].split(",").map(function (id) {
            return parseInt(id);
          });
        }
      }
    }

    if (document.location.pathname.indexOf("/booking-book") > -1) {
      state.action = "book";
    } else if (document.location.pathname.indexOf("/booking-complete") > -1) {
      state.action = "complete";
    } else {
      state.action = "calendar";
    }
    return values;
  }

  function queryFromState(state) {
    var queryItems = [];
    for (var key in state) {
      var value = state[key];
      if (key === "action" || key === "bsource" || key === "useCache") {
        continue;
      }
      if (key === "time" && value !== null) {
        value = value.replace(":", "");
      }
      if (cfg.DEFAULT_STATE[key] !== value && key !== "end" && value !== null) {
        queryItems.push(key + "=" + encodeURIComponent(value));
      }
    }
    if (queryItems.length > 0) {
      return "?" + queryItems.join("&");
    }
    return "";
  }

  function updateUrl(url, replace, func) {
    var state = st.get();
    var promise = $.Deferred();

    promise.then(function () {
      url += queryFromState(state);
      if (DEVELOPMENT) {
        console.log("Push: " + JSON.stringify(state));
      }
      if (cfg.ENABLE_PUSHSTATE && history.pushState) {
        var title = "Booking Calendar | Escape Manor";
        if (state.action === "book") {
          var slot = ns.data.getSelectedTimeSlot();
          title = slot.event.reservation.name + " " + ns.utils.formatDate(state.date) + " " + ns.utils.formatTime(state.time) + " | Escape Manor";
        }
        if (replace) {
          history.replaceState(state, title, url);
        } else {
          history.pushState(state, title, url);
        }
        document.title = title;
      } else {
        window.location = url;
      }
    });

    if (typeof func === "function") {
      func.apply(this, [promise]);
    } else {
      promise.resolve();
    }
    return promise.promise();
  }

  function bindPopState() {
    if (!cfg.ENABLE_PUSHSTATE) return;

    $(window).bind("popstate", function change(e) {
      if (st.isFinishedLoading() === false) {
        return;
      }
      if (e.originalEvent.state !== null) {
        if (DEVELOPMENT) {
          console.log("Pop: " + JSON.stringify(st.get()));
        }
        if (e.originalEvent && e.originalEvent.state) {
          if (e.originalEvent.state.action === "book") {
            st.set(e.originalEvent.state);
            return ns.book.showBook({ skipUpdateUrl: true });
          } else if (e.originalEvent.state.action === "calendar") {
            e.originalEvent.state.start = st.get().date;
            st.set(e.originalEvent.state);
            return ns.calendar.showCalendar({ clear: true, useCache: true });
          }
        }
      }

      st.reset();
      return ns.calendar.showCalendar();
    });
  }

  ns.url = {
    stateFromQuery: stateFromQuery,
    queryFromState: queryFromState,
    updateUrl: updateUrl,
    bindPopState: bindPopState,
  };
})(window.EM.booking);
